export function fixMojibake(input?: string | null): string {
  if (!input) return '';
  let s = String(input);
  // Common UTF-8 → Latin-1 mojibake sequences
  const map: Array<[RegExp, string]> = [
    [/Ã¤/g, 'ä'],
    [/Ã„/g, 'Ä'],
    [/Ã¶/g, 'ö'],
    [/Ã–/g, 'Ö'],
    [/Ã¼/g, 'ü'],
    [/Ãœ/g, 'Ü'],
    [/ÃŸ/g, 'ß'],
  ];
  for (const [re, rep] of map) s = s.replace(re, rep);

  // Handle already-lost bytes rendered as U+FFFD replacement chars in common words
  // e.g., "ganzt��gig" -> "ganztägig", "untert��gig" -> "untertägig"
  const r = '\\uFFFD';
  const reGanzt = new RegExp(`ganzt${r}${r}gig`, 'gi');
  const reUntert = new RegExp(`untert${r}${r}gig`, 'gi');
  const reTag = new RegExp(`t${r}${r}g`, 'gi');
  s = s.replace(reGanzt, 'ganztägig');
  s = s.replace(reUntert, 'untertägig');
  s = s.replace(reTag, 'täg');

  // Normalize to NFC to unify composed characters
  try { s = s.normalize('NFC'); } catch {}
  return s;
}
